
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const productfamilyApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listProductFamilies: builder.query ({
      query: (params) => `v2/productfamily/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["ProductFamily"]
    }),
    getProductFamily: builder.query ({
      query: (productfamily_id) => `v2/productfamily/${productfamily_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["ProductFamily"]
    }),

    updateProductFamily: builder.mutation ({
      query: ({productfamily_id, data}) => ({
        url: `v2/productfamily/${productfamily_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["ProductFamily"]
    }),
    deleteProductFamily: builder.mutation ({
      query: (productfamily_id) => ({
        url: `v2/productfamily/${productfamily_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["ProductFamily"]
    }),
    createProductFamily: builder.mutation ({
      query: (data) => ({
        url: `v2/productfamily/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["ProductFamily"]
    }),
  })
})


export const {
  useListProductFamiliesQuery,
  useLazyListProductFamiliesQuery,
  useGetProductFamilyQuery,
  useLazyGetProductFamilyQuery,

  useUpdateProductFamilyMutation,
  useDeleteProductFamilyMutation,
  useCreateProductFamilyMutation
} = productfamilyApi
